/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Spain_Guide_With_Skipper_P2Inputs */

const es_marketplace_seo_spain_guide_with_skipper_p2 = /** @type {(inputs: Marketplace_Seo_Spain_Guide_With_Skipper_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfecto para turismo costero, celebraciones o quien visita España sin licencia pero quiere una experiencia premium en yate, velero o lancha.`)
};

const gl_marketplace_seo_spain_guide_with_skipper_p2 = /** @type {(inputs: Marketplace_Seo_Spain_Guide_With_Skipper_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfecto para turismo costeiro, celebracións ou quen visita España sen licenza pero quere unha experiencia premium en iate, veleiro ou lancha.`)
};

const en_marketplace_seo_spain_guide_with_skipper_p2 = /** @type {(inputs: Marketplace_Seo_Spain_Guide_With_Skipper_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perfect for coastal tourism, celebrations or visitors without a licence who want a premium experience on a yacht, sailboat or motorboat.`)
};

/**
* | output |
* | --- |
* | "Perfect for coastal tourism, celebrations or visitors without a licence who want a premium experience on a yacht, sailboat or motorboat." |
*
* @param {Marketplace_Seo_Spain_Guide_With_Skipper_P2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_spain_guide_with_skipper_p2 = /** @type {((inputs?: Marketplace_Seo_Spain_Guide_With_Skipper_P2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Spain_Guide_With_Skipper_P2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_spain_guide_with_skipper_p2(inputs)
	if (locale === "en") return en_marketplace_seo_spain_guide_with_skipper_p2(inputs)
	return es_marketplace_seo_spain_guide_with_skipper_p2(inputs)
});